/* eslint-disable react/prop-types */
/* eslint-disable react/forbid-component-props */
import React, { useState } from 'react';
import { Avatar, Button, Card, Dropdown, Menu } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import "./MyUserProfile.css";
import * as _ from "lodash";
import { getOssUrl } from "metabase/lib/image";
import * as Urls from "metabase/lib/urls";
import { t } from "ttag";
import { connect } from "react-redux";
import { getFgaProject, getUser } from "metabase/selectors/user";
import { getGames } from "metabase/selectors/control";
import { getProjectAlias } from "metabase/ab/utils/utils";

const MyUserProfile = props => {
  const { user, onLogout, projectName, onChangeLocation, games } = props;
  const email = user?.email;
  const first_name = user?.first_name;
  const role = user?.role;
  const getRoleName = (role) => {
    return role;
  }
  const [ visible, setVisible ] = useState(false);

  const handleMenuClick = () => {
    setVisible(!visible);
  };
  const isAdmin = user && user.id === 186;
  // const isAdmin = user && user.is_superuser;
  const userName = user && user.name;
  const buttonConfig = [
    {
      title: "Games Manage",
      icon: null,
      link: `/ab/project/${projectName}/games-manage`,
    },
    {
      title: "User Config",
      icon: null,
      link: `/ab/project/${projectName}/user-config`,
    },
    {
      title: "Dashboard Config",
      icon: null,
      link: `/ab/project/${projectName}/dashboard-config`,
    },
    {
      title: "SQL query",
      icon: null,
      externalLink: Urls.newQuestion({ type: "native", creationType: "native_question" }),
      link: Urls.newQuestion({ type: "native", creationType: "native_question" }),
    },
    {
      title: "New dashboard",
      icon: null,
      externalLink: "dashboard/new",
      link: "dashboard/new",
    },
    /*{
      title: t`My Profile`,
      icon: null,
      link: `${Urls.myProfileUrl(userName)}`,
    },*/
    {
      title: t`Admin settings`,
      icon: null,
      link: "/admin",
    },
  ];

  const renderSingleRole = (object) => {
    const { role, project, color } = object;
    return (
      <div className="user-profile-menu__role-single" key={role}>
        <div className="flex align-center justify-center" style={{ gap: 6 }}>
          <div className="user-role__circle" style={{background: `${color}`}}/>
          <h3 style={{color: `${color}`}}>{role}</h3>
        </div>
        <ul>
          {
            project?.map(item => {
              return (
                <li key={item?.projectName} className={`flex align-center`} >
                  <Avatar size={12} src={item.icon}/> <span>{getProjectAlias(item)}</span>
                </li>
              )
            })
          }
        </ul>
      </div>
    )
  }

  const renderRolePanel = () => {
    return (
      <div className="user-profile-menu__role">
        {data3?.map(d => {
          return renderSingleRole(d)
        })}
        Give Access to Project Roles
      </div>
    )
  }
  const calProjectId = (str) => {
    const match = str.match(/\d+/);
    return match ? parseInt(match[0], 10) : null
  }
  const createData = () => {
    const roles = user?.roles
    const managerRoles = roles.filter(item => item?.role === "Manager")
    const dataUserRoles = roles.filter(item => item?.role === "Data User").filter(item => !managerRoles?.map(i => calProjectId(i.roleName))?.includes(item?.projectId))
    // const viewerRoles = roles.filter(item => item?.role === "Viewer")
    //   .filter(item => !managerRoles?.map(i => calProjectId(i.roleName))?.includes(item?.projectId))
    //   .filter(item => !dataUserRoles?.map(i => calProjectId(i.roleName))?.includes(item?.projectId))
    // games
    return [
      managerRoles.length > 0 && {
        role: "Project Admin",
        project: games.filter(item => managerRoles?.map(i => calProjectId(i.roleName))?.includes(item.projectId)),
        color: "#64F09C",
      },
      dataUserRoles.length > 0 && {
        role: "Raw Data Access",
        project: games.filter(item => dataUserRoles?.map(i => calProjectId(i.roleName))?.includes(item.projectId)),
        color: "#C1C7D0",
      },
      {
        role: "View only",
        project: games.filter(item => ![...managerRoles, ...dataUserRoles]?.map(i => calProjectId(i.roleName))?.includes(item.projectId)),
        color: "#FFBA68",
      },
    ].filter(Boolean)
  }

  const data3 = createData()

  const menu = (
    <Menu className="user-profile-menu">
      <Card className="user-profile-card">
        <div className="flex mb1">
          <Avatar size={32} src={getOssUrl("ab/profile.png?1=1")}/>
          <div className="flex flex-column ml1">
            <div className="flex align-center" style={{ gap: 10 }}>
              <h3>{_.startCase(_.lowerCase(first_name))}</h3>
            </div>
            <p>{email}</p>
          </div>
        </div>
        <Menu.Divider className="custom-divider"/>
        <div className="mr4"/>
        <h2>My Data Access</h2>
        {renderRolePanel()}
        <div className="mr4 mb2"/>
        <Menu.Divider className="custom-divider"/>
        <div className="mr4 mb2"/>
        <div className="flex flex-column" style={{ gap: 4 }}>
          {isAdmin && buttonConfig?.map(item => {
            return (
              <Button key={item.title} className="user-profile-button" onClick={() => onChangeLocation(item.link)}>
                {item.title}
              </Button>
            )
          })}
          <Button className="user-profile-button" onClick={() => onLogout?.()}>
            Sign Out
          </Button>
        </div>
      </Card>
    </Menu>
  );

  return (
    <div className="user-profile-container">
      <Dropdown
        overlay={menu}
        trigger={[ 'click' ]}
        visible={visible}
        onVisibleChange={handleMenuClick}
        overlayClassName="custom-dropdown"
        placement="bottomRight"
      >
        <div className="user-profile-header">
          <Avatar size={32} icon={<img alt={"profile"} src={getOssUrl("ab/profile.png?1=1")}/>}/>
          <span className="user-profile-name">{_.startCase(_.lowerCase(first_name))}</span>
          <DownOutlined className="dropdown-icon"/>
        </div>
      </Dropdown>
    </div>
  );
}

const mapStateToProps = (state, props) => {
  return {
    user: getUser(state),
    projectObject: getFgaProject(state),
    projectPath: props.params.project,
    menu: props.params.menu,
    games: getGames(state),
  };
};

export default connect(mapStateToProps)(MyUserProfile)
